import { render } from "./CandidatesDrawer.vue?vue&type=template&id=3dd2a2d7&scoped=true"
import script from "./CandidatesDrawer.vue?vue&type=script&lang=js"
export * from "./CandidatesDrawer.vue?vue&type=script&lang=js"

import "./CandidatesDrawer.vue?vue&type=style&index=0&id=3dd2a2d7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dd2a2d7"]])

export default __exports__